import axios from 'axios';
import _ from 'lodash';
import defaultParams from './defaultParams';
import config from '../../config';

let defaultParamsCopy = defaultParams;

// Create HTTP client
const http = axios.create({
  baseURL: config.API.offer[config.env],
  timeout: 20000,
});

const configHttp = axios.create({
  baseURL: config.API.configuration[config.env],
  timeout: 20000,
});

const sevenApiBaseUrl = config.API.sevenApi[config.env];

const replaceDefaultCompanyUuid = (params, { uuid, locale }) => {
  const paramsCopy = params;
  paramsCopy.params.company_uuid = uuid;
  paramsCopy.language.default = locale;
  return paramsCopy;
};

export default {
  loadMeta(params = {}, { uuid, locale }) {
    defaultParamsCopy = replaceDefaultCompanyUuid(defaultParamsCopy, { uuid, locale });
    let paramsCopy = _.merge({}, defaultParamsCopy);
    paramsCopy = _.merge(paramsCopy, params);

    return http.get('/getMeta', {
      params: paramsCopy,
    }).then(response => response.data);
  },

  loadMatch(params = {}) {
    let paramsCopy = _.merge({}, defaultParamsCopy);
    paramsCopy = _.merge(paramsCopy, params);

    return http.get('/getMatch', {
      params: paramsCopy,
    }).then(response => response.data);
  },

  loadOffer(params = {}) {
    let paramsCopy = _.merge({}, defaultParamsCopy);
    paramsCopy = _.merge(paramsCopy, params);

    return http.get('/getMatches', {
      params: paramsCopy,
    }).then(response => response.data);
  },

  loadTopOffer(params = {}, { uuid, locale }) {
    defaultParamsCopy = replaceDefaultCompanyUuid(defaultParamsCopy, { uuid, locale });

    let paramsCopy = _.merge({}, defaultParamsCopy);
    paramsCopy = _.merge(paramsCopy, params);

    return http.get('/getTopOffer', {
      params: paramsCopy,
    }).then(response => response.data);
  },

  loadOutrightsMeta(params = {}) {
    let paramsCopy = _.merge({}, defaultParamsCopy);
    paramsCopy = _.merge(paramsCopy, params);

    return http.get('/getMeta', {
      params: paramsCopy,
    }).then(response => response.data);
  },

  loadOutrights(params = {}) {
    let paramsCopy = _.merge({}, defaultParamsCopy);
    paramsCopy = _.merge(paramsCopy, params);

    return http.get('/getOutrights', {
      params: paramsCopy,
    }).then(response => response.data);
  },

  loadConfiguration(params) {
    return configHttp.get('/configuration', params).then(response => response.data);
  },

  loadTicketList(settings, params) {
    let dcUrlFragment = '';

    const companyConfig = config.companies[settings.companyUuid] || {};
    const hasCloudflareDc = sevenApiBaseUrl.indexOf('dcUrlCloudflareFragment' > -1);

    if (hasCloudflareDc) dcUrlFragment = companyConfig.dcUrlCloudflare || 'gb';

    const sevenApi = _.replace(sevenApiBaseUrl, '{dcUrlCloudflareFragment}', dcUrlFragment);

    return axios.get(`${sevenApi}/terminal-admin/device-tickets/${settings.cpvUuid}.json`, params).then(response => response.data);
  },

  http,
  configHttp,
};
